
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#000"}}),_c('path',{attrs:{"d":"M9.88 13.493c.214 0 .977.019 1.475.744-.043.033-.801.46-.801 1.418 0 1.11.967 1.503.995 1.513a4.136 4.136 0 01-.507 1.062c-.318.455-.654.915-1.162.915-.507 0-.64-.294-1.218-.294-.574 0-.778.303-1.238.303-.465 0-.792-.426-1.157-.943-.431-.621-.782-1.575-.782-2.48 0-1.447.943-2.22 1.873-2.22.488 0 .9.323 1.209.323.294 0 .75-.341 1.313-.341zm-.26-.612c-.252.303-.679.531-1.015.531a.548.548 0 01-.1-.01.71.71 0 01-.014-.137c0-.384.2-.768.408-1.01.27-.318.725-.55 1.095-.564.01.042.014.095.014.147 0 .384-.16.763-.388 1.043zm3.793-.654h2.76c1.366 0 2.3.934 2.3 2.314 0 1.356-.967 2.285-2.352 2.285h-1.484v2.243h-1.224v-6.842zm1.224 1.024v2.56h1.209c.872 0 1.384-.455 1.384-1.27 0-.84-.497-1.29-1.38-1.29h-1.213zm6.131 4.979c.712 0 1.242-.46 1.242-1.063v-.412l-1.17.076c-.66.043-.968.28-.968.702 0 .436.375.697.896.697zm-.346.924c-1 0-1.716-.607-1.716-1.555 0-.939.706-1.48 1.967-1.555l1.338-.08v-.437c0-.507-.342-.792-.977-.792-.54 0-.91.19-1.02.54h-1.11c.096-.915.954-1.498 2.187-1.498 1.332 0 2.081.65 2.081 1.75v3.542H22.04v-.711h-.08c-.29.502-.859.796-1.537.796zm4.06 1.797c-.072 0-.39-.004-.465-.018v-.963c.066.014.242.019.322.019.498 0 .778-.19.93-.669l.061-.227-1.854-5.211h1.29l1.214 4.049h.08l1.21-4.05h1.242l-1.873 5.354c-.441 1.29-.996 1.716-2.158 1.716z","fill":"#fff"}})])
          )
        }
      }
    